import React from "react";
import HomeIntroPNG from "assets/images/home/home-intro.png";
import { MyPageHead } from "../myPage/common";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const ServiceIntro = () => {
  const router = useNavigate();
  return (
    <ServiceIntroContainer>
      <MyPageHead title="서비스 소개" />
      <IntroImage src={HomeIntroPNG} alt="service intro" />
      <HomeButton onClick={() => router("/")}>플로웨이 홈으로 가기</HomeButton>
    </ServiceIntroContainer>
  );
};

export default ServiceIntro;

const ServiceIntroContainer = styled.div`
  position: relative;
  top: 0;
  left: 0;
`;

const IntroImage = styled.img`
  width: 100%;
`;

const HomeButton = styled.button`
  position: absolute;
  width: 264px;
  height: 56px;
  left: 50%;
  bottom: 80px;
  transform: translateX(-50%);
  cursor: pointer;

  background: rgba(0, 0, 0, 0.8);
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.24);
  border-radius: 16px;
  border: none;

  font-weight: 700;
  font-size: 18px;
  color: #ffffff;
`;
